// discoveryStateSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type GenerateFormSuccessResponse } from './ApplicationCard';

export interface ExistingConnectionDetailsState {
  loading: boolean;
  error: string | null;
  data: GenerateFormSuccessResponse | undefined;
}

const initialState: ExistingConnectionDetailsState = {
  loading: false,
  error: null,
  data: undefined,
};

const existingConnectionDetailsSlice = createSlice({
  name: 'existingConnectionDetails',
  initialState,
  reducers: {
    setExistingConnectionDetailsLoading: (
      state,
      action: PayloadAction<boolean>
    ) => ({
      ...state,
      loading: action.payload,
    }),
    setExistingConnectionDetailsError: (
      state,
      action: PayloadAction<string | null>
    ) => ({
      ...state,
      error: action.payload,
    }),
    resetExistingConnectionDetailsState: () => initialState,
  },
});

export const {
  setExistingConnectionDetailsLoading,
  setExistingConnectionDetailsError,
  resetExistingConnectionDetailsState,
} = existingConnectionDetailsSlice.actions;
export default existingConnectionDetailsSlice;
